import React, { useState, useEffect, SyntheticEvent } from 'react'
import styled, { css } from 'styled-components'
import { observer } from 'mobx-react-lite'
import { useCrewCalender } from '../StoreCrewCalender'

import _merge from 'lodash/merge'
import _map from 'lodash/map'
import _find from 'lodash/find'
import _reject from 'lodash/reject'
import { useSnackbar } from '@src/components/GlobalSnackbar'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { useAppStore } from '@src/AppStore'

import IconButton from '@material-ui/core/IconButton'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import ShiftMoreActionsMenu from './ActionMenu'


import { useSelectedShifts } from '@src/utils/hooks/StoreSelectedShifts'
import CrewNoteMoreActionsMenu from './CrewNoteActionMenu'
import { apiCrewNoteRemove } from '@src/apis/crew-note-remove'
import DuplicateCrewNoteDialog from './DuplicateCrewNoteDialog'
import CameraIcon from '@src/layout/Header/parts/CameraIcon'


interface Props {
  data: any,
  currentIndex: number,
  crewIndex: number,
  batchIndex: number,
  total: number,
  className: string,
  inDragLayer: boolean,
  onClick(e: SyntheticEvent): void,
  onPrevious(): void,
  onNext(): void

}

const CrewNoteItem = ({
  data,
  currentIndex,
  crewIndex,
  batchIndex,
  total,
  inDragLayer,
  onClick,
  onPrevious,
  onNext,
  className

}: Props) => {




  const { serialId, } = useAppStore()
  const { alert, alertError } = useSnackbar()
  const { currentBatch, selectedStart, selectedEnd, crews, startCrewIndex, endCrewIndex, dragStartDate, setDragStartDate, updateSelectedStartBox, goRefresh, drss, setDrss, isCalendarControlsDisabled, setIsCalendarLoading, setCalendarControlsDisabled } = useCrewCalender()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [isDuplicateDialogOpen, setDuplicateDialogOpen] = useState<boolean>(false)
  const [isSelected, setIsSelected] = useState<boolean>(false)
  const [date, setDate] = useState<string>('')
  const [canDragShift, setCanDragShift] = useState<boolean>(true)
  const [drsDialogOpen, setDrsDialogOpen] = useState<boolean>(false)
  const [duplicateNoteDialogOpen, setDuplicateNoteDialogOpen] = useState<boolean>(false)
  const [crewNoteData, setCrewNoteData] = useState<any>(null)
  const { selectedShiftCount, selectedShifts, addSelectedShift, removeSelectedShift, clearSelectedShifts, drsStatusCrewsCantBeChanged, isDragHappening, setIsDragHappening } = useSelectedShifts()

  useEffect(() => {
    let found = selectedShifts.find((o: any) => o.CrewCalendarNotesID === data.CrewCalendarNotesID);
    if (found)
      setIsSelected(true)
    else
      setIsSelected(false)
  }, [selectedShiftCount, currentIndex])
  useEffect(() => {
    if (currentBatch[selectedEnd])
      setDate(currentBatch[selectedEnd].toISOString())
  }, [selectedEnd])

  useEffect(() => {
    if (data !== null) {

      //console.log(`DRSItem useEffect() data=${JSON.stringify(data, null, 2)}`)
    }
  }, [data])



  const handleMoreClicked = (e: React.SyntheticEvent<any>) => {
    e.stopPropagation()
    setAnchorEl(e.target as HTMLElement)
  }
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    //console.log(`DRSItem handleClick() e.ctrlKey=${e.ctrlKey}`)
    if (e.ctrlKey || e.altKey || e.metaKey) {
      if (isSelected) {

        return
      }

      if (isCalendarControlsDisabled) {
        alert({
          type: 'error',
          message: `Shifts can't be dragged while the Calendar is updating.`
        })
        return
      }

      return
    }
    clearSelectedShifts()
    onClick(e)
  }
  const handleDelete = async () => {
    if (!(data)) {
      alert({
        type: 'error',
        message: `CrewNote #${data.CrewCalendarNotesID} cannot be removed.`
      })
      return
    }
    try {
      setIsCalendarLoading(true)
      setCalendarControlsDisabled(true)
      apiCrewNoteRemove({
        noteId: data.CrewCalendarNotesID,
        serialId,
      }).then(() => {

        goRefresh()
        alert({
          message: `CrewNote #${data.CrewCalendarNotesID} was deleted.`
        })

        //window.location.reload();
      })
    } catch (e) {
      setIsCalendarLoading(false)
      setCalendarControlsDisabled(false)
      alertError()
    }
  }

  const handlePrevious = (e: React.SyntheticEvent<any>) => {
    e.stopPropagation()
    onPrevious()
  }
  const handleNext = (e: React.SyntheticEvent<any>) => {
    e.stopPropagation()
    onNext()
  }


  useEffect(() => {

  }, [])

  return <Wrapper isSelected={isSelected} inDragLayer={inDragLayer} isDragHappening={isDragHappening} className={className}>
    <ShiftBlock onClick={handleClick} isNight={0} isSelected={isSelected} style={{ background: data.RGBColorCode }}>
   
      <NavIcons>
        <MoreButton isNight={0} size='small' onClick={handleMoreClicked}>
          <MoreVertIcon fontSize="small" style={{ padding: 0, height: 14, width: 14 }} />
        </MoreButton>
        <ShiftNo>
          {`${currentIndex + 1}/${total}`}
         
          {total !== 1 &&
            <React.Fragment>

              <NavIconButton
                isNight={0}
                disabled={total === 1}
                size='small'
                onClick={handlePrevious} >
                <KeyboardArrowLeft fontSize="small" style={{ padding: 0, height: 14, width: 14 }} />
              </NavIconButton>
              <NavIconButton
                isNight={0}
                disabled={total === 1}
                size='small'
                onClick={handleNext} >
                <KeyboardArrowRight fontSize="small" style={{ padding: 0, height: 14, width: 14 }} />
              </NavIconButton>
              
            </React.Fragment>
          }
        
        </ShiftNo>
      </NavIcons>
      <ShiftInfoRow isNight={0}>
        {
          data.Comment.split("\n").map((cm: string,cmindex: any) => (
            <p key={'cmindex_'+cmindex}  style={{ margin: '0px' }}>{cm}</p>
          ))
        }
      </ShiftInfoRow>



    </ShiftBlock>
    {anchorEl !== null && <CrewNoteMoreActionsMenu
      anchorEl={anchorEl}
      onClose={() => setAnchorEl(null)}

      onDuplicateNote={() => {
        setCrewNoteData(data);
        setDuplicateNoteDialogOpen(true);
      }}
      onDelete={() => {
        handleDelete()
        setAnchorEl(null)
      }}

    />
    }
    {duplicateNoteDialogOpen &&
      <DuplicateCrewNoteDialog
        open={duplicateNoteDialogOpen}
        crewNoteData={crewNoteData}
        IsAcknowledge={true}
        onClose={() => {
          setDuplicateNoteDialogOpen(false)
        }}
        onSave={() => {
          goRefresh()
          setDuplicateNoteDialogOpen(false)
          goRefresh();
        }} />
    }

  </Wrapper>
}

const Wrapper = styled.div<{ isSelected: boolean, inDragLayer: boolean, isDragHappening: boolean }>`
  margin-bottom: 5px;
  :last-child {
      margin - bottom: 0px;
  }
  ${props => {
    if (!props.inDragLayer && props.isSelected && props.isDragHappening) {
      return css`
        opacity: 0.3;
      `
    }
  }}
`

const ShiftBlock = styled.div<{ isNight: number, isSelected: boolean }>`
  flex-grow: 1;
  height: 100%;
  position: relative;
  background-color: #F5F5F5;
  color: #6E6E6E;
  font-size: 10px;
  cursor: pointer;
  border-radius: 8px;
  font-weight: bold;
  padding: 0 8px 8px 8px;
  border: 1px solid #009688;
  ${props => {
    if (props.isNight) {
      if (props.isSelected) {
        return css`
          background-color: #9bcbfb;
          color: #fff;
          border-style: dashed;
        `
      } else {
        return css`
          background-color: #009688;
          color: #fff;
          border: none;
        `
      }
    }
  }}
  ${props => {
    if (!props.isNight && props.isSelected) {
      return css`
        background-color: #e6f2fe;
        border-style: dashed;
      `
    }
  }}
`

const MoreButton = styled(IconButton) <{ isNight: number }>`
  position: absolute;
  right: 0;
  top: 0;
  color: #0A9688;
  ${props => {
    if (props.isNight) {
      return css`
        color: #fff;
      `
    }
  }}
`

const ShiftNo = styled.div`
  font-size: 12px;
  height: 30px;
  line-height: 30px;
`

const NavIcons = styled.div`
  white-space: nowrap;
`

const NavIconButton = styled(IconButton) <{ isNight: number }>`
  color: #0A9688;
  ${props => {
    if (props.isNight) {
      return css`
        color: #F5F5F5;
      `
    }
  }}
`
const ShiftInfoRow = styled.div<{ isNight: number }>`
  min-height: 28px;
  line-height: 28px;
  font-size: 14px;
  font-weight: normal;
  color: #6E6E6E;
  

  word-break: break-all;
  word-wrap: break-word;

  ${props => {
    if (props.isNight) {
      return css`
        color: #F5F5F5;
      `
    }
  }}
`
const Status = styled.div<{ isNight: number }>`
  border-radius: 16px;
  line-height: 16px;
  font-size: 10px;
  text-align: center;
  background-color: #0A9688;
  padding: 4px 10px;
  font-weight: normal;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${props => {
    if (props.isNight) {
      return css`
      color: #0A9688;
      background-color: #fff;
      `
    }
  }}
`
export default observer(CrewNoteItem)